<template>
<div class="chapter">
<div class="inner_page">
<a id="page_viii"></a>
<h2 class="fmtitle">Acknowledgements</h2>
<p class="noindentf">My gratitude to all who helped, in particular:</p>
<p class="noindentf">Brigadier Henry Wilson and his team at Pen &amp; Sword Ltd, my publishers, especially my liaison officer Matt Jones.</p>
<p class="noindentf">Johnson &amp; Alcock Ltd, my agents, especially my liaison officer Ed Wilson.</p>
<p class="noindentf">Pamela Covey, my editor.</p>
<p class="noindentf">Jon Wilkinson, who had the brilliant idea of having a Russian Hurricane on the cover as a symbol of the Hurricane’s worldwide service.</p>
<p class="noindentf">The Birmingham &amp; Midland Institute &amp; Library, the Taylor Library and Mr Christopher Shores for the photographs.</p>
<p class="noindentf">Thank you everyone.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Acknowledgements.vue?4c627e5c